import React from "react";
import { Icon, PlainButton, Thumbnail } from "@culturehq/components";

import inviteTypes from "constants/inviteTypes";

const UserSuggestion = ({ user: { avatar, name, title } }) => (
  <>
    <Thumbnail image={avatar.thumbUrl} />
    <span>{name}<br /><small>{title}</small></span>
  </>
);

const EntitySuggestion = ({ entity }) => {
  const { icon, name } = inviteTypes[entity.type];

  return (
    <>
      {entity.logo ? <Thumbnail image={entity.logo} /> : <div className="chq-icon"><Icon icon={icon} /></div>}
      <span>{entity.name}<br /><small>({name}, {entity.userCount} users)</small></span>
    </>
  );
};

const Suggestion = ({ active, onClick, suggestion }) => {
  const onButtonClick = event => {
    event.stopPropagation();
    onClick(suggestion);
  };

  return (
    <PlainButton aria-current={active} className="chq-edi--sg--et" onClick={onButtonClick}>
      {
        suggestion.type === "users"
          ? <UserSuggestion user={suggestion} />
          : <EntitySuggestion entity={suggestion} />
      }
    </PlainButton>
  );
};

export default Suggestion;
